module.exports = __webpack_public_path__ + "static/media/all-card_color_big.2c74c509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/all-card_color_big.png
// module id = ./src/assets/media/icons/all-card_color_big.png
// module chunks = 16